import { createStructuredSelector } from 'reselect';

// Grants Dashboard States
export const selectGrantsDashboardStates = (state) => state.grantsDashboard;

// recent charities
export const selectRecentCharities = (state) => {
  const { recentCharities } = selectGrantsDashboardStates(state);
  return recentCharities;
};

// saved charities
export const selectSavedCharities = (state) => {
  const { savedCharities } = selectGrantsDashboardStates(state);
  return savedCharities;
};

// savedCharity loading state
export const selectSavedCharityLoadingStatus = (state) => {
  const { savedCharity } = selectGrantsDashboardStates(state);
  return savedCharity.isLoading;
};

// searchCharity state
export const selectSearchCharity = (state) => {
  const { searchCharity } = selectGrantsDashboardStates(state);
  return searchCharity;
};

// searchCharity state loading state
export const selectSearchCharityLoadingStatus = (state) => {
  const { isLoading } = selectSearchCharity(state);
  return isLoading;
};

// search charity data
export const selectSearchCharityData = (state) => {
  const { data } = selectSearchCharity(state);
  return data;
};

// isSearchCharity data
export const selectIsSearchCharity = (state) => {
  const { isCharitySearch } = selectSearchCharity(state);
  return isCharitySearch;
};

// guidestar count data
export const selectGuideStarSearchCount = (state) => {
  const { guidestarSearchCount } = selectSearchCharity(state);
  return guidestarSearchCount;
};

// grantHistory data
export const selectGrantHistoryData = (state) => {
  const { grantHistory } = selectGrantsDashboardStates(state);
  return grantHistory;
};

// grantSearchTerm data
export const selectSearchTermData = (state) => {
  const { grantSearchTerm } = selectGrantsDashboardStates(state);
  return grantSearchTerm;
};

// gemini search term data
export const selectGeminiSearchTermData = (state) => {
  const { grantGeminiSearchTerm } = selectGrantsDashboardStates(state);
  return grantGeminiSearchTerm;
};

// search gemini
export const selectGemini = (state) => {
  const { searchGemini } = selectGrantsDashboardStates(state);
  return searchGemini;
};

// search gemini data
export const selectGeminiData = (state) => {
  const { data } = selectGemini(state);
  return data;
};

// isGemini data
export const selectIsGeminiSearch = (state) => {
  const { isGeminiSearch } = selectGemini(state);
  return isGeminiSearch;
};

// search gemini response
export const selectSearchGeminiResponse = (state) => {
  const { searchGeminiStringResponse } = selectGemini(state);
  return searchGeminiStringResponse;
};

// pendingGrantsLoading
export const selectPendingGrantsLoading = (state) => {
  const { pendingGrantsLoading } = selectGrantsDashboardStates(state);
  return pendingGrantsLoading;
};

// pendingAgreements
export const selectPendingAgreements = (state) => {
  const { pendingAgreements } = selectGrantsDashboardStates(state);
  return pendingAgreements;
};

// pendingGrants
export const selectPendingGrants = (state) => {
  const { pendingGrants } = selectGrantsDashboardStates(state);
  return pendingGrants;
};

// pendingActiveSchedule
export const selectPendingActiveSchedule = (state) => {
  const { pendingActiveSchedule } = selectGrantsDashboardStates(state);
  return pendingActiveSchedule;
};

export const selectServerDown = (state) => {
  const { searchCharity } = selectGrantsDashboardStates(state);
  return searchCharity.serverDown;
};

export const charitySelectStates = createStructuredSelector({
  recentGrants: selectRecentCharities,
  savedCharities: selectSavedCharities,
  isLoadingSaved: selectSavedCharityLoadingStatus,
  isLoadingCharity: selectSearchCharityLoadingStatus,
  searchCharity: selectSearchCharityData,
  isCharitySearch: selectIsSearchCharity,
  grantHistory: selectGrantHistoryData,
  grantSearchTerm: selectSearchTermData,
  grantGeminiSearchTerm: selectGeminiSearchTermData,
  searchGeminiData: selectGeminiData,
  isGeminiSearch: selectIsGeminiSearch,
  guidestarSearchCount: selectGuideStarSearchCount,
  searchGeminiStringResponse: selectSearchGeminiResponse,
  pendingGrantsLoading: selectPendingGrantsLoading,
  pendingAgreements: selectPendingAgreements,
  pendingGrants: selectPendingGrants,
  pendingActiveSchedule: selectPendingActiveSchedule,
  serverDown: selectServerDown,
});
